<template>
  <div class="grid-separator-container">
    <hr class="grid-separator" />
    <p class="grid-separator-title">{{ separatorName }}</p>
  </div>
</template>

<script>

export default {
  name: 'GridSeparator',
  props: {
    separatorName: String
  }
}
</script>

<style scoped lang="scss">
.grid-separator-title{
  font-size: 17px;
  font-weight: bold;
  margin-left: 10px;
  margin-bottom: 5px;
}
.grid-separator{
  margin-top: 0;
  border: none;
  height: 1px;
  color: lightgray;
  background-color: lightgray;
}
</style>
